import { Task, Timestamp } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle216 } from 'shared/assets/icons';

import { MetaInteraction } from '../meta-interaction';

export type MetaCompleteHabitProps = {
  task: Task;
  onUpdate: (completedAt: Timestamp | null) => void;
};

export const MetaCompleteHabit: React.FC<MetaCompleteHabitProps> = ({
  task,
  onUpdate,
}) => {
  const { t } = useTranslation();
  const isCompleted = !!task.completedAt;

  const handleClick = () => {
    if (isCompleted) {
      onUpdate(null);
      return;
    }

    onUpdate(new Date());
  };

  return (
    <MetaInteraction
      icon={CheckCircle216}
      label={
        isCompleted
          ? t('general.labels.habit.uncomplete')
          : t('general.labels.habit.complete-forever')
      }
      placeholder={t('general.labels.habit.complete-forever')}
      onClick={handleClick}
    />
  );
};
